/**
 *
 *
 *
 *
 *
 *
 */
/*                                     */
import { o_global } from "@gr-common/async/namespaces";
import { otto } from "@gr-exports/async/nexus";
import { asExport } from "@gr-exports/async/core";
import { noop } from "@gr-common/async/function";
/*                                               */
export const device = o_global.device ?? {};
export const os = device.os;
export const browser = device.browser;
export const type = device.type;
/*                                */
export const hybrid = device.hybrid;
/*                                */
export const orientation = device.orientation;
/**
 *
 */
export const deviceAsync = /*           */ asExport(otto, "device", {});
/**
 *
 *
 *
 *
 */
export const pointerType = /*           */ asExport(deviceAsync, "pointerType", {});
/**
 *
 *
 *
 */
export const getPointerType = /*           */ asExport(deviceAsync, "getPointerType", noop);
/**
 *
 *
 *
 */
export const getScreenSpecs = /*           */ asExport(deviceAsync, "getScreenSpecs", noop);
